Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebAccessibilityRole = void 0;
var _reactNative = require("react-native-web");
var WebAccessibilityRole = exports.WebAccessibilityRole = function WebAccessibilityRole(role) {
  if (_reactNative.Platform.OS === 'web') {
    return role;
  }
  return undefined;
};